import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ChatBubble = ({ text, delay, x, y, author, color }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.8, y: y + 20 }}
    whileInView={{ opacity: 1, scale: 1, y }}
    viewport={{ once: true }}
    transition={{ delay, duration: 0.5 }}
    style={{ left: `${x}%`, top: `${y}%` }}
    className="absolute glass-card p-4 rounded-2xl border-white/10 shadow-xl max-w-[200px] flex flex-col gap-2"
  >
    <div className="flex items-center gap-2">
      <div className={`w-6 h-6 rounded-full bg-${color}-500/20 flex items-center justify-center border border-${color}-500/30`}>
        <SafeIcon icon={FiIcons.FiUser} className={`text-[10px] text-${color}-400`} />
      </div>
      <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tighter">{author}</span>
    </div>
    <p className="text-xs text-slate-300 leading-relaxed italic">"{text}"</p>
  </motion.div>
);

const DialogueVisual = () => {
  return (
    <div className="relative w-full aspect-video bg-[#070b14] rounded-3xl overflow-hidden border border-white/5">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#3b82f6_1px,transparent_1px)] [background-size:20px_20px]"></div>
      
      {/* Floating Bubbles */}
      <ChatBubble author="Reddit User" color="orange" text="Which link building service actually works in 2024?" x={10} y={20} delay={0.2} />
      <ChatBubble author="SEO Strategist" color="blue" text="PRBoost helps us get real placements on high DR sites." x={55} y={15} delay={0.5} />
      <ChatBubble author="Quora Expert" color="purple" text="Focus on ecosystem authority, not just single links." x={15} y={60} delay={0.8} />
      <ChatBubble author="Agency Owner" color="emerald" text="The white-label reports saved our client meetings." x={60} y={65} delay={1.1} />

      {/* Central Connector */}
      <motion.div 
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 4, repeat: Infinity }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-blue-600/5 rounded-full border border-blue-500/20 flex items-center justify-center"
      >
        <div className="text-center">
          <SafeIcon icon={FiIcons.FiMessageCircle} className="text-4xl text-blue-400 mb-2 mx-auto" />
          <span className="text-[10px] font-bold text-blue-300 uppercase tracking-widest block">Real Engagement</span>
        </div>
      </motion.div>
    </div>
  );
};

export default DialogueVisual;